import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';
import { TagManager } from '@/services/utilities';

import { exportRequest } from '../services/actions';
import { selectExportApi } from '../services/selectors';

export const useExport = () => {
    const dispatch = useDispatch();

    const { inProgress } = useAppSelector(selectExportApi);

    const handleExport = () => {
        TagManager.push('used_import_export');
        dispatch(exportRequest());
    };

    return {
        inProgress,
        handleExport,
    };
};
